import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { DomainDesignation } from "@constants";
import { asRoundedPercentage } from "@components/Filters/number.js";
import { centeredOffset, fullOffset } from "@utils/Directives/offset";
export default {
  directives: {
    centeredOffset,
    fullOffset
  },
  filters: {
    asRoundedPercentage
  },
  props: {
    domain: {
      type: Object,
      default() {
        return {};
      }
    },
    facts: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      designation: {}
    };
  },
  mounted() {
    this.setTheme();
  },
  computed: {
    programCategory() {
      return this.$store.getters.entityProgramCategory;
    },
    programName() {
      return this.programCategory.Description;
    },
    entityPrograms() {
      return this.$store.state.entityProgramCategories.filter(x => x.CycleId === this.$store.state.cycleId && x.ProgramCategoryId === this.programCategory.ProgramCategoryId);
    },
    designationCounts() {
      let data = {};
      for (let key in DomainDesignation) {
        if (DomainDesignation[key].range) data[DomainDesignation[key].label] = {
          config: DomainDesignation[key],
          count: 0
        };
      }
      for (let i = 0; i < this.entityPrograms.length; i++) {
        let program = this.entityPrograms[i];
        let domainIndicators = this.domain.Indicators.map(m => m.DomainIndicatorId);
        let domainFacts = program.Facts.filter(f => domainIndicators.includes(f.DomainIndicatorId));
        let designation = DomainDesignation.getDesignation(domainFacts, this.domain);
        data[designation.label].count++;
      }
      return data;
    }
  },
  watch: {
    facts() {
      this.setTheme();
    }
  },
  methods: {
    setTheme() {
      this.designation = DomainDesignation.getDesignation(this.facts, this.domain);
    },
    asPercentage(val) {
      return `${Math.round(val * 100)}%`;
    }
  }
};